import { AtlasThemeProvider } from '@diligentcorp/atlas-theme-mui';
import ExperimentalAtlasThemeProvider from '@diligentcorp/atlas-theme-mui/lib/AtlasThemeProvider/ExperimentalAtlasThemeProvider';
import { lensThemeOptions } from '@diligentcorp/atlas-theme-mui/lib/themes/lens/index.js';
import React, { createContext, useContext } from 'react';

interface AtlasMuiThemeProviderProps {
  children: React.ReactNode;
}

// Set by AtlasMuiThemeRoot, which resolves the feature flag once at the app
// root. Kept in context so this module stays free of Redux imports — it is
// rendered by a lot of unit tests that have no store.
export const AtlasLightRootContext = createContext(false);

export const AtlasLightThemeProvider = ({
  children,
  useCssBaseline,
}: {
  children?: React.ReactNode;
  useCssBaseline: boolean;
}) => (
  <ExperimentalAtlasThemeProvider
    tokenMode="atlas-light"
    useCssBaseline={useCssBaseline}
  >
    {children}
  </ExperimentalAtlasThemeProvider>
);

const LensThemeProvider = ({ children }: { children: React.ReactNode }) => (
  <AtlasThemeProvider themeOptions={lensThemeOptions}>
    {children}
  </AtlasThemeProvider>
);

export const AtlasMuiThemeProvider: React.FC<AtlasMuiThemeProviderProps> = ({
  children,
}) => {
  const hasRoot = useContext(AtlasLightRootContext);

  if (!hasRoot) return <LensThemeProvider>{children}</LensThemeProvider>;

  return (
    <AtlasLightThemeProvider useCssBaseline={false}>
      {children}
    </AtlasLightThemeProvider>
  );
};
